import React from "react";
import styled from "styled-components";

const StyledTabs = styled.div`
  width: 648px;
`;

const TabButtons = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0 1rem;
  border-bottom: 2px solid #c4c4c4;
`;

const TabButton = styled.div`
  padding: 1rem 1.5rem;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  border: 2px solid #0a0a13;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    color: #c4c4c4;
  }
`;

const TabButtonActive = styled(TabButton)`
  position: relative;
  border: 2px solid #c4c4c4;
  cursor: default;
  color: #62fa54;
  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 1rem;
    background-color: #0a0a13;
  }
  &:hover {
    color: #62fa54;
  }
`;

const TabBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.5rem;
`;

const TabItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 138px;
  padding: 1rem;
  border: 1px solid #2f9dd9;
  color: ${({ color }) => color || "#ffffff"};
  font-size: 14px;
  text-transform: uppercase;
  text-align: center;
`;

export const Tabs = ({ tabData }) => {
  const [tabActive, setTabActive] = React.useState(0);
  const tabActiveItems = tabData[tabActive].items;
  return (
    <StyledTabs>
      <TabButtons>
        {tabData.map((tab) => {
          if (tabActive === tab.id) {
            return <TabButtonActive>{tab.header}</TabButtonActive>;
          }
          return (
            <TabButton
              onClick={() => {
                setTabActive(tab.id);
              }}
              key={tab.header}
            >
              {tab.header}
            </TabButton>
          );
        })}
      </TabButtons>
      <TabBody>
        {tabActiveItems.map((contentItem) => (
          <TabItem key={contentItem.text} color={contentItem.color}>
            {contentItem.text}
          </TabItem>
        ))}
      </TabBody>
    </StyledTabs>
  );
};
